<button class="btn btn-light btn-sm" *ngIf= "isDownloadVisible" title="Download" (click)="onDownload($event)">
  <i class="fa fa-download" aria-hidden="true"></i>
</button>
<button class="btn btn-light btn-sm" *ngIf= "isSaveVisible" title="Save" (click)="onSave($event)">
  <i class="fa fa-save" aria-hidden="true"></i>
</button>
<button class="btn btn-danger btn-sm" *ngIf= "isDeleteVisible" title="Delete" (click)="onDelete($event)">
  <i class="fa fa-trash" aria-hidden="true"></i>
</button>
